module.exports = "<div id=\"mapContainer\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src634836211/src/src/app/dashboard/map/map.component.html
// module id = ../../../../../src/app/dashboard/map/map.component.html
// module chunks = main